<style scoped lang="scss" type="text/scss">
    .popup-container {
        .content {
            margin-bottom: 2rem;
        }
    }
</style>

<template>
    <el-dialog :title="title"
               class="popup-container"
               :visible.sync="visibleSync"
               width="50%"
               :close-on-click-modal="false"
    >
        <div class="content">{{ content }}</div>
        <el-button type="primary" plain @click="cancel()">关闭</el-button>
    </el-dialog>
</template>

<script>
    import Card from '../../../components/card/index';

    export default {
        name: '',
        components: {
            Card
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            info: Object
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            return {
                visibleSync: null
            };
        },
        computed: {
            title () {
                return this.info.title;
            },
            content () {
                return this.info.content;
            }
        },
        methods: {
            cancel () {
                this.visibleSync = false;
            }
        }
    };
</script>
